/* eslint-disable no-shadow */
/* eslint-disable require-jsdoc */
import React from 'react';
import { useTheme } from '@mui/system';
import Text from '../../../components/Text.js';
import * as Theme from '../../../theme/index.js';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';

/**
 * 
 * @param {*} param0 
 * @returns 
 */
const RateTable = ({
  pricing,
  isAsoDental,
  isAsoHealth
}) => {
  const theme = useTheme();
  const styles = {
    pricingContainer: {
      maxWidth: 1000,
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    block: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    headerBar: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      marginTop: 20,
      marginBottom: 10,
      padding: 8,
      backgroundColor: theme.palette.primary.main
    },
    row: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: "5px 30px 0 50px"
    },
    rowCondensed: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row',
      padding: 8
    },
    line: {
      width: '98%',
      height: 2,
      opacity: 0.5,
      backgroundColor: theme.palette.primary.main,
      margin: "10px auto"
    },
    amountBlock: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      alignItems: 'center'
    }
  };
  const _numberWithCommas = (number, noDollar = false) => {
    if (!number) {
      return 0;
    }
    if (noDollar) {
      return `${number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }
    return `$${number.toFixed(3).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
  };
  const _getHealthGrossRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    return pricing.drugs[coverageType].grossRate + pricing.majorMedical[coverageType].grossRate + pricing.paramedicals[coverageType].grossRate + pricing.eyeExams[coverageType].grossRate + pricing.eyeGlassesAndContacts[coverageType].grossRate + pricing.requiredMedicalEyewear[coverageType].grossRate;
  };
  const _getHealthNetRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    return pricing.drugs[coverageType].netRate + pricing.majorMedical[coverageType].netRate + pricing.paramedicals[coverageType].netRate + pricing.eyeExams[coverageType].netRate + pricing.eyeGlassesAndContacts[coverageType].netRate + pricing.requiredMedicalEyewear[coverageType].netRate;
  };
  const _getHealthPastRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    if (!pricing.drugs[coverageType].pastRates) {
      return 0;
    }
    return pricing.drugs[coverageType].pastRates.grossRate + pricing.majorMedical[coverageType].pastRates.grossRate + pricing.paramedicals[coverageType].pastRates.grossRate + pricing.eyeExams[coverageType].pastRates.grossRate + pricing.eyeGlassesAndContacts[coverageType].pastRates.grossRate + pricing.requiredMedicalEyewear[coverageType].pastRates.grossRate;
  };
  const _getDentalGrossRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    return pricing.basicDental[coverageType].grossRate + pricing.majorDental[coverageType].grossRate + pricing.orthodontics[coverageType].grossRate;
  };
  const _getDentalNetRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    return pricing.basicDental[coverageType].netRate + pricing.majorDental[coverageType].netRate + pricing.orthodontics[coverageType].netRate;
  };
  const _getDentalPastRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    if (!pricing.basicDental[coverageType].pastRates) {
      return 0;
    }
    return pricing.basicDental[coverageType].pastRates.grossRate + pricing.majorDental[coverageType].pastRates.grossRate + pricing.orthodontics[coverageType].pastRates.grossRate;
  };
  const _getEfapGrossRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    return pricing.employeeAssistance[coverageType].grossRate + pricing.medicalSecondOpinion[coverageType].grossRate + pricing.eldercare[coverageType].grossRate + pricing.mentalHealthOnDemand[coverageType].grossRate;
  };
  const _getEfapPastRate = (pricing, coverageType) => {
    coverageType = coverageType.toLowerCase();
    if (!pricing.employeeAssistance[coverageType].pastRates) {
      return 0;
    }
    return pricing.employeeAssistance[coverageType].pastRates.grossRate + pricing.medicalSecondOpinion[coverageType].pastRates.grossRate + pricing.eldercare[coverageType].pastRates.grossRate + pricing.mentalHealthOnDemand[coverageType]?.pastRates?.grossRate || 0;
  };
  return /*#__PURE__*/React.createElement("div", {
    style: styles.pricingContainer
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.block
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      flex: 1,
      justifyContent: 'space-between',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Text, {
    largest: true,
    bold: true
  }, i18n.t(tokens.labels.advisor.rateSummary)), /*#__PURE__*/React.createElement(Text, {
    small: true,
    color: Theme.colors.mediumGrey
  }, i18n.t(tokens.labels.advisor.previousRates))), /*#__PURE__*/React.createElement("div", {
    style: styles.headerBar
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, i18n.t(tokens.labels.coverage.benefit)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, i18n.t(tokens.labels.advisor.rate)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    color: Theme.colors.surface,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, i18n.t(tokens.titles.carrier))), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.lifeInsurance)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.lifeInsurance.family.grossRate)), pricing.lifeInsurance.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.lifeInsurance.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.lifeInsurance.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.accidentalDeathAndDismemberment)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.deathDismemberment.family.grossRate)), pricing.deathDismemberment.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.deathDismemberment.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.deathDismemberment.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.dependentLife)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.dependentLife.family.grossRate)), pricing.dependentLife.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.dependentLife.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.dependentLife.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.longTermDisability)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.ltd.family.grossRate)), pricing.ltd.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.ltd.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.ltd.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.shortTermDisability)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.std.family.grossRate)), pricing.std.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.std.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.std.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.criticalIllness)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.solo.grossRate)), pricing.criticalIllness.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.duo.grossRate)), pricing.criticalIllness.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllness.family.grossRate)), pricing.criticalIllness.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllness.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllness.carrier || 'N/A')), pricing.criticalIllnessSpouse.family.grossRate > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.criticalIllnessSpouse)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.solo.grossRate)), pricing.criticalIllnessSpouse.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.duo.grossRate)), pricing.criticalIllnessSpouse.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessSpouse.family.grossRate)), pricing.criticalIllnessSpouse.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessSpouse.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessSpouse.carrier || 'N/A'))), pricing.criticalIllnessChild.family.grossRate > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.criticalIllnessChild)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.family.grossRate)), pricing.criticalIllnessChild.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.duo.grossRate)), pricing.criticalIllnessChild.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.criticalIllnessChild.family.grossRate)), pricing.criticalIllnessChild.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.criticalIllnessChild.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.criticalIllnessChild.carrier || 'N/A'))), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.labels.signup.extendedHealthCare)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'solo')) : _numberWithCommas(_getHealthGrossRate(pricing, 'solo'))), _getHealthPastRate(pricing, 'solo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'solo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'duo')) : _numberWithCommas(_getHealthGrossRate(pricing, 'duo'))), _getHealthPastRate(pricing, 'duo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'duo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoHealth ? _numberWithCommas(_getHealthNetRate(pricing, 'family')) : _numberWithCommas(_getHealthGrossRate(pricing, 'family'))), _getHealthPastRate(pricing, 'family') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getHealthPastRate(pricing, 'family')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.drugs.carrier || pricing.paramedicals.carrier || 'N/A')), pricing.outOfProvince.family.grossRate > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.outOfCountry)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.solo.grossRate)), pricing.outOfProvince.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.duo.grossRate)), pricing.outOfProvince.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.outOfProvince.family.grossRate)), pricing.outOfProvince.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.outOfProvince.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.outOfProvince.carrier || 'N/A'))), pricing.stopLoss.family.grossRate > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.stopLoss)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.solo.grossRate)), pricing.stopLoss.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.duo.grossRate)), pricing.stopLoss.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.stopLoss.family.grossRate)), pricing.stopLoss.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.stopLoss.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.stopLoss.carrier || 'N/A'))), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.employeeFamilyAssistanceProgram)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'solo'))), _getEfapPastRate(pricing, 'solo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'solo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'duo'))), _getEfapPastRate(pricing, 'duo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'duo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(_getEfapGrossRate(pricing, 'family'))), _getEfapPastRate(pricing, 'family') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getEfapPastRate(pricing, 'family')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.employeeAssistance.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.dental)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'solo')) : _numberWithCommas(_getDentalGrossRate(pricing, 'solo'))), _getDentalPastRate(pricing, 'solo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'solo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'duo')) : _numberWithCommas(_getDentalGrossRate(pricing, 'duo'))), _getDentalPastRate(pricing, 'duo') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'duo')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  },
  // Show net rate for ASO since we don't charge the gross rate for ASO
  isAsoDental ? _numberWithCommas(_getDentalNetRate(pricing, 'family')) : _numberWithCommas(_getDentalGrossRate(pricing, 'family'))), _getDentalPastRate(pricing, 'family') > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(_getDentalPastRate(pricing, 'family')))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.basicDental.carrier || 'N/A')), pricing.virtualHealthcare && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.virtualHealthCare)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.solo.grossRate)), pricing.virtualHealthcare.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.duo.grossRate)), pricing.virtualHealthcare.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.virtualHealthcare.family.grossRate)), pricing.virtualHealthcare.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.virtualHealthcare.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.virtualHealthcare.carrier || 'N/A'))), pricing.financialAwareness && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0", i18n.t(tokens.titles.financialAwareness)), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.solo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.solo.grossRate)), pricing.financialAwareness.solo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.solo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.duo)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.duo.grossRate)), pricing.financialAwareness.duo.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.duo.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')), /*#__PURE__*/React.createElement("div", {
    style: styles.rowCondensed
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1
    }
  }, "\xA0\xA0\xA0\xA0", i18n.t(tokens.labels.advisor.family)), /*#__PURE__*/React.createElement("div", {
    style: styles.amountBlock
  }, /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, _numberWithCommas(pricing.financialAwareness.family.grossRate)), pricing.financialAwareness.family.pastRates?.grossRate > 0 && /*#__PURE__*/React.createElement(Text, {
    medium: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    },
    color: Theme.colors.mediumGrey
  }, _numberWithCommas(pricing.financialAwareness.family.pastRates.grossRate))), /*#__PURE__*/React.createElement(Text, {
    medium: true,
    bold: true,
    customStyle: {
      flex: 1,
      textAlign: 'center'
    }
  }, pricing.financialAwareness.carrier || 'N/A')))), /*#__PURE__*/React.createElement("span", {
    id: "pricing-preview"
  }));
};
export default RateTable;